<template>
  <html>
    <head>
      <meta charset="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
      />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <link rel="icon" type="image/png" href="favicon.png" />
      <title>Restó APP</title>
    </head>
    <body class="login">
      <div class="d-flex align-items-center min-vh-100 bg-auth">
        <div class="container">
          <div class="justify-content-center row">
            <div class="my-5 col-xl-4 col-md-5 col-12">
              <h1 class="display-4 text-center mb-3">Recuperar contraseña</h1>
              <p class="text-muted text-center mb-5">
                Enviaremos un link de acceso a tu correo electrónico para que
                puedas recuperar tu cuenta
              </p>
              <form v-on:submit.prevent="recovery">
                <div class="form-group mb-5">
                  <label class="form-label">Email</label
                  ><input type="email" v-model="email" class="form-control" />
                </div>
                <button type="submit" class="w-100 mb-3 btn btn-primary btn-lg">
                  Recuperar cuenta
                </button>
                <p class="text-center">
                  <small class="text-muted text-center">
                    <a v-on:click="goToPage('Register')">
                      No tengo cuenta. Crear cuenta ahora</a
                    >.
                  </small>
                </p>
              </form>
              <PopUp :show="success" @close="success = false; goToPage('login')">
                <template #body>
                  <p>{{ success_msg }}</p>
                </template>
              </PopUp>
              <PopUp :show="error" @close="error = false">
                <template #body>
                  <p>{{ error_msg }}</p>
                </template>
              </PopUp>
            </div>
          </div>
        </div>
      </div>
    </body>
  </html>
</template>

<script>
import axios from "axios";
import PopUp from "../components/PopUp.vue";

export default {
  name: "Recovery",
  components: { PopUp },
  data: function () {
    return {
      email: "",
      error: false,
      success: false,
      error_msg: "",
      success_msg: "",
    };
  },
  methods: {
    recovery() {
      let json = {
        email: this.email,
      };

       axios
        .post("/reset-user-init", json)
        .then((data) => {
          if (data.status == 200) {
            this.success = true;
            this.success_msg = "Mail enviado con exito";
          } else {
            this.error = true;
            this.error_msg = "El mail ingresado no está registrado";
          }
        })
    },

    goToPage(page) {
      this.$router.push({ name: page });
    },
  },
};
</script>

<style scoped></style>
